export const delay = (time: number) =>
  new Promise((resolve) => setTimeout(resolve, time));

export const refetchInterval = 5000;
